import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export const HousingProvider = styled(Box)`
  ${({ theme: { colors, breakpoints } }) => `
    display: flex;
    background-color: ${colors.greys.greys5};
    height: 150px;
    overflow: hidden;

    ${breakpoints.up('md')} {
      margin-top: 24px;
    }
  `}
`;

export const Logo = styled(Grid)`
  ${({ theme: { palette, colors, breakpoints } }) => `
    width: 150px;
    height: 100%;
    background-color: ${palette.common.white};
    border: 2px solid ${colors.greys.greys5};
    flex-shrink: 0;
    padding: 20px;

    ${breakpoints.up('sm')} {
      width: 205px;
    }
  `}
`;

export const Name = styled(Typography)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  text-transform: uppercase;
  padding: 20px;
`;
